import { GetContentType,ContentType,CreateContent,Content } from "./ContentBase";
import { Operation } from "./OperationBase";
import {ComponentType} from "./ContentComponent";

export function CreateOperationContent(setContent:(newContent:Node)=>void, varIdx:number, curComp:ComponentType, content:any):Operation {
  let ctType=GetContentType(content);
  let Content:Content;

  let rv:Operation= {
    GetData: (args:any[])=> args[varIdx],
    Update: (v:any)=> {
      let ctType2=GetContentType(v);
      if(ctType2===ContentType.NoChange) return;
      if(ctType===ctType2 && Content.MatchForUpdate(v)) {
        Content.Update(v)
      } else {
        Content.Unload();
        ctType=ctType2;
        Content=CreateContent(v,setContent,curComp);
      }
    },
    Unload:()=> ()=> Content.Unload(),
  }

  Content=CreateContent(content,setContent,curComp);
  return rv;
}


